import { render, staticRenderFns } from "./PelatihanPreTestReport.vue?vue&type=template&id=d41b12ba"
import script from "./PelatihanPreTestReport.vue?vue&type=script&lang=js"
export * from "./PelatihanPreTestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports